import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { BankInstitutionValidationSchema } from '../schemas/create.schema'

interface UseUpdateBankInstitutionProps {
  bankInstitutionId: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: AxiosError) => void
}

export const useUpdateBankInstitution = ({ bankInstitutionId, onSuccess, onError }: UseUpdateBankInstitutionProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateBankInstitution'],
    mutationFn: async (form: BankInstitutionValidationSchema) => {
      const bank = {
        ...form,
        account_validation_regex: form.account_validation_regex || '',
        branch_validation_regex: form.branch_validation_regex || ''
      }

      return await privateAxios.put(`/bank_institutions/${bankInstitutionId}`, bank)
    },
    onSuccess,
    onError,
  })
}
